export default {
	'Package Verif Master': {
		output_folder: '/media/DATA/elements_pikachu/verifmaster/'
	},
	'Generic DCP Ingest': {
		working_directory: '/media/DATA/1305j552_dcp/GRAVITY'
	}
}



// WEBPACK FOOTER //
// ./src/pages/maestro/forms/job_or_task_form_default_values.js